import React from 'react';

import useScrollDirection from '@pkg/hooks/useScrollDirection';

import { StyledYatHand } from '../../../GroupHeader/GroupHeaderImage/styles';
import { GroupCreateNewPod } from '../GroupCreateNewPod';
import { GroupItemAvatarSkeleton } from '../styles';
import { type NavigatorProps } from '../types';

import { GroupItemMobile } from './components';

import {
    GroupItemNameSkeleton,
    GroupItemSkeletonMobile,
    GroupLogoMobileLink,
    GroupsNavigationMobileContainer,
    GroupsNavigationMobileList,
    GroupsNavigationMobileLogo,
    GroupsNavigationMobileMask,
    GroupsNavigationMobileScroll,
} from './styles';

const GROUP_PLACEHOLDER_ITEMS_LENGTH = 10;

export const GroupsNavigationMobile = ({
    isLoading,
    groupsData,
    handleItemClick,
    currentUserId,
    loadMoreItem,
}: NavigatorProps) => {
    const scrollDir = useScrollDirection();

    return (
        <GroupsNavigationMobileContainer $fixed={scrollDir === 'up'}>
            <GroupsNavigationMobileMask>
                <GroupsNavigationMobileLogo>
                    <GroupLogoMobileLink to="/">
                        <StyledYatHand />
                    </GroupLogoMobileLink>
                </GroupsNavigationMobileLogo>
                <GroupsNavigationMobileScroll>
                    <GroupsNavigationMobileList>
                        {isLoading &&
                            [...Array(GROUP_PLACEHOLDER_ITEMS_LENGTH)].map((_, index) => {
                                return (
                                    <GroupItemSkeletonMobile key={`podnav-skeleton-${index}`}>
                                        <GroupItemAvatarSkeleton />
                                        <GroupItemNameSkeleton />
                                    </GroupItemSkeletonMobile>
                                );
                            })}

                        {!isLoading && <GroupCreateNewPod isMobile />}

                        {!isLoading &&
                            groupsData &&
                            groupsData?.map((group) => {
                                return (
                                    <GroupItemMobile
                                        key={`podnav-${group.id}`}
                                        id={group.id}
                                        name={group.name}
                                        privacy={group.privacy}
                                        members={group?.members?.total || 0}
                                        followers={group?.follower_count || 0}
                                        avatarUrl={group.header_image || null}
                                        isOwner={currentUserId === group.owner}
                                        isMember={group.is_member || false}
                                        owner={group.owner}
                                        onClick={() => handleItemClick(group.slug)}
                                    />
                                );
                            })}
                        {loadMoreItem}
                    </GroupsNavigationMobileList>
                </GroupsNavigationMobileScroll>
            </GroupsNavigationMobileMask>
        </GroupsNavigationMobileContainer>
    );
};
